import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import VideoPlayer from "./VideoPlayer";
import Videos from "./Videos";

const VideoPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [currentVideo, setCurrentVideo] = useState(null);
  const [showPlayer, setShowPlayer] = useState(false);

  // Define your video data inline (must match the data in your Videos component)
  const videos = [
    {
      name: "Becoming a Certified Internal Auditor",
      topic: "Internal Audits",
      thumbnail: "/images/CIA_Certification.png",
      videoUrl: "/videos/CIA_Smartauditx.mp4",
      slug: "becoming-a-certified-internal-auditor",
      summary:
        "This video explains the key steps and tips for becoming a certified internal auditor, including exam preparation and career advice. It covers the certification process, necessary qualifications, and how this credential can boost your career in internal auditing."
    },
    {
      name: "Managing Risks Effectively",
      topic: "Risk Management",
      thumbnail: "/images/video-thumbnail-2.jpg",
      videoUrl: "/videos/risk-management.mp4",
      slug: "managing-risks-effectively",
      summary:
        "Learn strategies for identifying and managing risks effectively in complex business environments."
    },
    {
      name: "Compliance Essentials",
      topic: "Compliance",
      thumbnail: "/images/video-thumbnail-3.jpg",
      videoUrl: "/videos/compliance-essentials.mp4",
      slug: "compliance-essentials",
      summary:
        "An overview of compliance best practices and regulatory requirements for organizations."
    }
  ];

  // When the slug changes, look up the corresponding video and update the current video.
  useEffect(() => {
    if (slug) {
      const video = videos.find((v) => v.slug === slug);
      setCurrentVideo(video);
    } else {
      setCurrentVideo(null);
    }
  }, [slug]);

  // If no slug is provided, show the Videos grid.
  if (!slug) {
    return <Videos />;
  }

  // If the slug doesn't match any video, display an error message.
  if (!currentVideo) {
    return (
      <div className="p-6">
        <p>Video not found.</p>
        <button
          onClick={() => navigate("/videos")}
          className="mt-4 text-blue-500 hover:underline"
        >
          Back to Videos
        </button>
      </div>
    );
  }

  // Share the current video URL (with the slug) to the clipboard.
  const handleShare = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => alert("Video link copied to clipboard!"))
      .catch(() => alert("Failed to copy video link."));
  };

  return (
    <div className="p-6">
      <button
        onClick={() => navigate("/videos")}
        className="text-blue-500 hover:underline"
      >
        &larr; Back to Videos
      </button>
      <h2 className="text-2xl font-bold text-gray-800 mt-4 mb-4">
        {currentVideo.name}
      </h2>
      <p className="mb-4 text-gray-700">{currentVideo.summary}</p>
      {/* Button to show the video player */}
      <button
        onClick={() => setShowPlayer(true)}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
      >
        Play Video
      </button>
      {showPlayer && (
        <div className="mt-4">
          <VideoPlayer currentVideo={currentVideo} />
        </div>
      )}
      {/* Share Button */}
      <button
        onClick={handleShare}
        className="mt-4 px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
      >
        Share Video
      </button>
      <p className="mt-2 text-gray-600">
        Video Link:{" "}
        <span className="underline break-all">{window.location.href}</span>
      </p>
    </div>
  );
};

export default VideoPage;
